import { render, staticRenderFns } from "./JobPreview.vue?vue&type=template&id=610f7a5c&scoped=true&"
import script from "./JobPreview.vue?vue&type=script&lang=js&"
export * from "./JobPreview.vue?vue&type=script&lang=js&"
import style0 from "./JobPreview.vue?vue&type=style&index=0&id=610f7a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610f7a5c",
  null
  
)

export default component.exports